// The sheet editors' print options, from PrintLayout on the server, as
// SegmentedChoice options.

// PrintLayout::PRINT_MODES.
export const printModeOptions = (modes) =>
  modes.map((m) => ({ value: m.key, label: m.label, hint: m.hint }));

const FRACTIONS = { 0.25: "¼", 0.5: "½" };

// PrintLayout::MARGINS.
export const marginOptions = (margins) =>
  margins.map((m) => ({ value: m.key, label: m.label, hint: `${FRACTIONS[m.horizontal] ?? m.horizontal}″ sides` }));
